const XMLNS = 'http://www.w3.org/2000/svg';
const WIDTH = '24';
const HEIGHT = '24';
const VIEWBOX = '0 0 24 24';
const FILL = 'none';

export { XMLNS, WIDTH, HEIGHT, VIEWBOX, FILL };
